import React from "react";
import { BnbLabel } from "../../../../utils/labels";
import type { AccentColourType, ExtraType } from "../../../../../../../common-deprecated/types/CommonTypes";
import Extra from "../../common/extras/Extra";
import { find } from "../../../../../../../common-deprecated/utils";
import * as PackStyles from "./styles/Pack";

type OptionalPackEquipmentType = {
    equipment: ExtraType[];
    selectedEquipment: string[];
    equipmentSelect: (extra: ExtraType) => void;
    equipmentDeselect: (extra: ExtraType) => void;
    selectSecondaryAccentColour?: (colour: AccentColourType) => void;
    secondaryAccentColours?: AccentColourType[];
    secondaryAccentColour?: AccentColourType | null;
    enabled: boolean;
    disableFinanceId?: boolean;
    disableCheckbox?: boolean;
};

// If anything ever changes here, note that this has an equivalent component in build v1.
const OptionalPackEquipment = (props: OptionalPackEquipmentType): JSX.Element => {
    const {
        equipment,
        enabled,
        selectedEquipment,
        secondaryAccentColour,
        equipmentDeselect,
        equipmentSelect,
        disableFinanceId,
        disableCheckbox,
    } = props;
    const { selectSecondaryAccentColour, secondaryAccentColours } = props;
    return (
        <PackStyles.OptionalContainer>
            <PackStyles.FooterTitle>
                <BnbLabel label="packsOptional" />
            </PackStyles.FooterTitle>
            <PackStyles.Grid>
                {equipment.map((equipmentItem) => {
                    const isEquipped = selectedEquipment.includes(equipmentItem.id);
                    let equippedOptionId = "";
                    if (secondaryAccentColour) {
                        const selectedOption = equipmentItem.options.find(
                            (option) => option.colour && option.colour.id === secondaryAccentColour.id,
                        );
                        if (selectedOption) equippedOptionId = selectedOption.id;
                    }
                    return (
                        <Extra
                            key={equipmentItem.id}
                            optional={!disableCheckbox}
                            disableFinanceId={disableFinanceId}
                            enabled={enabled}
                            extra={equipmentItem}
                            equipped={isEquipped}
                            onSelect={() => {
                                if (enabled) {
                                    if (isEquipped) equipmentDeselect(equipmentItem);
                                    else equipmentSelect(equipmentItem);
                                }
                            }}
                            onOptionSelect={(optionId: string) => {
                                if (enabled) {
                                    const option = find(optionId, equipmentItem.options);
                                    if (!isEquipped) equipmentSelect(equipmentItem);
                                    if (option && option.colour && selectSecondaryAccentColour) {
                                        selectSecondaryAccentColour(option.colour);
                                    }
                                }
                            }}
                            equippedOptionId={equippedOptionId}
                            secondaryAccentColours={secondaryAccentColours}
                            background
                        />
                    );
                })}
            </PackStyles.Grid>
        </PackStyles.OptionalContainer>
    );
};

export default OptionalPackEquipment;
